module.exports = __webpack_public_path__ + "img/04_old.15f4807c.png";